import React from 'react';
import { withTranslation } from 'react-i18next';

import ContentHeader from './Layout/ContentHeader';
import ContentColumn from './Layout/ContentColumn';
import { Cover } from './Helper/Cover';

const Loading = withTranslation()(({ t }) => (
  <>
    <Cover className="column image-cover" backgroundImage='url("/images/cover-main.png")' />
    <div className="wrapper">
      <ContentHeader />
      <ContentColumn>
        <div className="wrapper-shrink">
          <h1 className="loading">{t('Loading...')}</h1>
        </div>
      </ContentColumn>
    </div>
  </>
));

export default Loading;
